import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import English translations
import enCommon from './locales/en/common.json';
import enPublic from './locales/en/public.json';
import enAuth from './locales/en/auth.json';
import enValidation from './locales/en/validation.json';

// Import Spanish translations
import esCommon from './locales/es/common.json';
import esPublic from './locales/es/public.json';
import esAuth from './locales/es/auth.json';
import esValidation from './locales/es/validation.json';

// Define the resources with proper namespace structure.
//
// The "admin" namespace is not here: it is registered by ./adminNamespace,
// which the admin shell imports, so it ships with the admin chunk instead of
// in the entry chunk every public visitor downloads. Nor is "formGuide", the
// application form's guide: src/components/public/formGuide/formGuideNamespace.ts
// registers it, so it ships with the form's chunk.
const resources = {
  en: {
    common: enCommon,
    public: enPublic,
    auth: enAuth,
    validation: enValidation,
  },
  es: {
    common: esCommon,
    public: esPublic,
    auth: esAuth,
    validation: esValidation,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'public', 'auth', 'admin', 'validation'],

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'moe-language',
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    react: {
      useSuspense: true,
    },
  });

export default i18n;
